import React from "react";
import PropTypes from "prop-types";

class ConfirmCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
    };
  }

  click = () => {
    const { onChange } = this.props;
    const { checked } = this.state;
    this.setState({ checked: !checked });
    onChange && onChange(!checked);
  };

  render() {
    const { checked } = this.state;
    const { text, disabled, className } = this.props;
    return (
      <div
        className={`confirm-checkbox-container ${
          disabled ? "confirm-checkbox-container-disabled" : ""
        } ${className || ""}`}
        style={{
          pointerEvents: disabled ? "none" : "auto",
        }}
        onClick={this.click}
        tabIndex={disabled ? "-1" : "0"}
      >
        <img
          alt=""
          src={require(`@/assets/images/confirm-checkbox-${
            checked ? "checked" : "normal"
          }.svg`)}
        />
        <div className="confirm-checkbox-container-text">{text}</div>
      </div>
    );
  }
}

ConfirmCheckbox.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ConfirmCheckbox;
